// شارة «شات الموقع» (0117): كم عميلًا ينتظر في الطابور + كم محادثة مفتوحة عندي.
//
// **من النبضة** (27/09/2026): العدّاد يأتي مع `/pulse` كل عشر ثوانٍ مع بقيّة العدّادات، لا بسؤالٍ مستقلّ.
// وحين يظهر منتظرٌ لم يكن، أو تصل رسالةُ زائرٍ جديدة في محادثتي وأنا خارج الشاشة، تُسمع نغمة الجرس.
// وبلا مزوّد نبضة (الاختبارات القديمة) يُسأل `/chats/summary` كل عشر ثوانٍ كما كان.
import { useEffect, useRef, useState } from 'react';
import { get, type ChatSummary } from '../lib/api.ts';
import { usePulse } from '../lib/pulse.tsx';
import { playNotificationSound } from '../notifications/notificationSound.ts';
import { systemNotify } from '../notifications/systemNotify.ts';

const POLL_MS = 10_000;

export function useChatSummary(enabled: boolean, onChatScreen: boolean): number {
  const pulse = usePulse();
  const live = pulse !== null && pulse.healthy;   // نبضةٌ فاشلة = بلا نبضة (مراجعة 27/09/2026)
  const [badge, setBadge] = useState(0);
  const last = useRef<ChatSummary | null>(null);
  const onScreen = useRef(onChatScreen);
  onScreen.current = onChatScreen;

  const apply = (s: ChatSummary) => {
    const prev = last.current;
    // شاتٌ جديد وصلك بالدور (active زاد) يرنّ في أيّ شاشة — ورسالةٌ جديدة من عميلك تُسمع خارج
    // شاشة الشات (داخلها تسمعها نافذة المحادثة نفسها) (0123، مراجعة 23/09/2026)
    if (prev && (s.waiting > prev.waiting || s.active > prev.active
        || (!onScreen.current && s.lastVisitorSeq > prev.lastVisitorSeq))) {
      playNotificationSound();
      systemNotify('💬 شات الموقع', s.waiting > prev.waiting ? 'عميل جديد مستنّي في شات الموقع' : 'رسالة جديدة من عميل في شات الموقع', 'site-chat');   // قرار المالك 01/10/2026
    }
    last.current = s;
    setBadge(s.waiting + s.active);
  };

  // مع النبضة
  const chats = pulse?.data?.chats ?? null;
  useEffect(() => {
    if (!live) return;
    if (!enabled || !chats) { setBadge(0); last.current = null; return; }
    apply(chats);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [live, enabled, chats]);

  // بلا نبضة: كما كان
  useEffect(() => {
    if (live) return;
    if (!enabled) { setBadge(0); last.current = null; return; }
    let alive = true;
    const tick = async () => {
      try { const s = await get<ChatSummary>('/chats/summary'); if (alive) apply(s); }
      catch { if (alive) setBadge(0); }
    };
    void tick();
    const id = setInterval(() => { void tick(); }, POLL_MS);
    return () => { alive = false; clearInterval(id); };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [enabled, live]);

  return badge;
}
